import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Space,
  Card,
  Form,
  Col,
  Select,
  List,
  Typography,
  Divider,
} from "antd";
import "./index.scss";
import API_SERVICE from "shared/services/api-service";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import { setConnectorId, setDiallerAssignmentFilter, setFilterData, setFilterListDetails, setIsAssignToMe, setIsShowFilter, setLeadPageNo, setLoanType, setLocation, setManagerHierarchy, setRestFilterData, setSelectedFilterListDetails } from "shared/redux/lead-reducer";
import { setBulkLoginConnectorId, setBulkLoginDiallerAssignmentFilter, setBulkLoginFilterData, setBulkLoginFilterListDetails, setBulkLoginIsAssignToMe, setBulkLoginIsShowFilter, setBulkLoginPageNo, setBulkLoginLoanType, setBulkLoginLocation, setBulkLoginManagerHierarchy, setBulkLoginResetFilterData, setBulkLoginSelectedFilterListDetails } from "shared/redux/bulkLogin-reducer";
import {setFollowUpConnectorId, setFollowUpFilterData, setFollowUpFilterListDetails, setFollowUpIsAssignToMe, setFollowUpIsShowFilter, setFollowUpPageNo, setFollowUpLoanType, setFollowUpLocation, setFollowUpManagerHierarchy, setFollowUpRestFilterData, setFollowUpSelectedFilterListDetails, setFollowUpDiallerAssignmentFilter } from "shared/redux/followUp-reducer";
import FollowUp from "components/Follow-Up/FollowUp";
const { Option } = Select;
const { Title, Text } = Typography;

interface ILeadFilter {
key:any,
type:any                          
}
const LeadFilter: React.FunctionComponent<ILeadFilter> = (props: ILeadFilter) => {
  const {
    key,
    type
  } = props;

  const [count, setCount] = useState(0);
  const [loanTypes, setLoanTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [disabledDepartment, setDisabledDepartment] = useState<string[]>([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const lead: any = useSelector((state: RootState) => state.lead);
  const bulkLoginLead: any = useSelector((state: RootState) => state.bulkLoginLead);
  const followUp:any = useSelector((state:RootState)=> state.followUp)
  const {appColors}: any = useSelector((state: RootState) => state.common);

  let userDetails = localStorage.getItem("user") as any;
  if (userDetails) {
    userDetails = JSON.parse(userDetails);
  }

  useEffect(() => {
    if (type === "LEAD"){
      form.setFieldsValue({
        REGIONAL_HEAD: lead.selectedFilterListDetails["REGIONAL_HEAD"],
        UNIT_MANAGER: lead.selectedFilterListDetails["UNIT_MANAGER"],
        SALES_MANAGER: lead.selectedFilterListDetails["SALES_MANAGER"],
        TEAM_LEADER: lead.selectedFilterListDetails["TEAM_LEADER"],
        SALES_EXECUTIVE: lead.selectedFilterListDetails["SALES_EXECUTIVE"],
        CONNECTOR: lead.selectedFilterListDetails["CONNECTOR"],
        SUB_CONNECTOR: lead.selectedFilterListDetails["SUB_CONNECTOR"],
        DIALLER_ASSIGNMENT_FILTER: lead.diallerAssignmentFilter ?? undefined,
        LOCATION: lead.location,
        LOAN_TYPE: lead.loanType,
        ASSIGNED_TO_ME: (lead.isAssignToMe ? ("" + lead.isAssignToMe) : undefined)
      });
    }
    else if (type === "FOLLOW_UP"){
      form.setFieldsValue({
        REGIONAL_HEAD: followUp.selectedFilterListDetails["REGIONAL_HEAD"],
        UNIT_MANAGER: followUp.selectedFilterListDetails["UNIT_MANAGER"],
        SALES_MANAGER: followUp.selectedFilterListDetails["SALES_MANAGER"],
        TEAM_LEADER: followUp.selectedFilterListDetails["TEAM_LEADER"],
        SALES_EXECUTIVE: followUp.selectedFilterListDetails["SALES_EXECUTIVE"],
        CONNECTOR: followUp.selectedFilterListDetails["CONNECTOR"],
        SUB_CONNECTOR: followUp.selectedFilterListDetails["SUB_CONNECTOR"],
        DIALLER_ASSIGNMENT_FILTER: followUp.diallerAssignmentFilter ?? undefined,
        LOCATION: followUp.location,
        LOAN_TYPE: followUp.loanType,
        ASSIGNED_TO_ME: (followUp.isAssignToMe ? ("" + followUp.isAssignToMe) : undefined)
      });
    }
    else {
      form.setFieldsValue({
      REGIONAL_HEAD: bulkLoginLead.selectedFilterListDetails["REGIONAL_HEAD"],
      UNIT_MANAGER: bulkLoginLead.selectedFilterListDetails["UNIT_MANAGER"],
      SALES_MANAGER: bulkLoginLead.selectedFilterListDetails["SALES_MANAGER"],
      TEAM_LEADER: bulkLoginLead.selectedFilterListDetails["TEAM_LEADER"],
      SALES_EXECUTIVE: bulkLoginLead.selectedFilterListDetails["SALES_EXECUTIVE"],
      CONNECTOR: bulkLoginLead.selectedFilterListDetails["CONNECTOR"],
      SUB_CONNECTOR: bulkLoginLead.selectedFilterListDetails["SUB_CONNECTOR"],
      DIALLER_ASSIGNMENT_FILTER: bulkLoginLead.diallerAssignmentFilter ?? undefined,
      LOCATION: bulkLoginLead.location,
      LOAN_TYPE: bulkLoginLead.loanType,
      ASSIGNED_TO_ME: (bulkLoginLead.isAssignToMe ? ("" + bulkLoginLead.isAssignToMe) : undefined)
    });
    }
    if (Object.keys(lead.filterListDetails).length === 0 || Object.keys(followUp.filterListDetails).length === 0  || Object.keys(bulkLoginLead.filterListDetails).length === 0) {
      getLists(userDetails?.userDetails?.userId, "");
    }
    getUsersPermissionList();
    generateDisabledDepartment();
  }, [])

  const getDepartmentName = (name, isKey) => {
    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      const hierarchyList = enumValues?.find(
        (item: any) => item.propertyName === "HIERARCHY"
      );
      const tmpDepartment = hierarchyList?.keyAndDisplayValueList?.find(
        (item: any) => isKey ? item.key === name : item.value === name
      );
      return (isKey ? tmpDepartment?.value : tmpDepartment?.key) ?? name;
    }
    return name;
  }

  const getDiallerAssignmentOptions = () => {
    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      const diallerAssignmentOptions = enumValues?.find(
        (item: any) => item.propertyName === "DIALLER_ASSIGNMENT_FILTER"
      )?.keyAndDisplayValueList
      return (
        <>
          {
            diallerAssignmentOptions?.map((item: any, i) => <Option key={`${item.key}-${i}`} value={item.key}>{item.value}</Option>)
          }
        </>
      )
    }
    return <></>
  }

  const generateDisabledDepartment = () => {
    const tmp = [""];
    let name = getDepartmentName(userDetails?.userDetails?.designation, false);
    tmp.push("REGIONAL_HEAD")
    if (name === "REGIONAL_HEAD") {
      setDisabledDepartment(tmp);
      return;
    }
    tmp.push("UNIT_MANAGER")
    if (name === "UNIT_MANAGER" || name === "Unit Head") {
      setDisabledDepartment(tmp);
      return;
    }
    tmp.push("SALES_MANAGER")
    if (name === "SALES_MANAGER") {
      setDisabledDepartment(tmp);
      return;
    }
    tmp.push("TEAM_LEADER")
    if (name === "TEAM_LEADER") {
      setDisabledDepartment(tmp);
      return;
    }
    tmp.push("SALES_EXECUTIVE")
    if (name === "SALES_EXECUTIVE") {
      setDisabledDepartment(tmp);
      return;
    }
  }

  const getUsersPermissionList = () => {
    API_SERVICE.getUsersPermission(userDetails?.userDetails?.userId).then(({ data }: any) => {
      if (data.payload) {
        setLoanTypes(data.payload.loanProducts.filter((type) => type.selected));
        setLocations(data.payload.locations.filter((type) => type.selected));
      }
    });
  };

  const getLists = (userId, name) => {
    API_SERVICE.getHeirarchyUsers(userId).then(({ data }: any) => {
      if (data.payload) {
        const position = getHierarchyPosition(name);
        if (position <= 6) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "SUB_CONNECTOR", "value": (data.payload["Sub Connector"] ?? []) })) 
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "SUB_CONNECTOR", "value": (data.payload["Sub Connector"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "SUB_CONNECTOR", "value": (data.payload["Sub Connector"] ?? []) }));
          //let temp = Object.assign(filterListData, { "SUB_CONNECTOR": data.payload["Sub Connector"] ?? [] });
          //setFilterListData(temp);
        }
        if (position <= 5) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "CONNECTOR", "value": (data.payload["Connector"] ?? []) }))
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "CONNECTOR", "value": (data.payload["Connector"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "CONNECTOR", "value": (data.payload["Connector"] ?? []) }));
          //let temp = Object.assign(filterListData, { "CONNECTOR": data.payload["Connector"] ?? [] });
          //setFilterListData(temp);
        }
        if (position <= 4) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "SALES_EXECUTIVE", "value": (data.payload["Sales Executive"] ?? []) }))
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "SALES_EXECUTIVE", "value": (data.payload["Sales Executive"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "SALES_EXECUTIVE", "value": (data.payload["Sales Executive"] ?? []) }));
          //let temp = Object.assign(filterListData, { "SALES_EXECUTIVE": data.payload["Sales Executive"] ?? [] });
          //setFilterListData(temp);
        }
        if (position <= 3) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "TEAM_LEADER", "value": (data.payload["Team Leader"] ?? []) }))
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "TEAM_LEADER", "value": (data.payload["Team Leader"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "TEAM_LEADER", "value": (data.payload["Team Leader"] ?? []) }));
          //let temp = Object.assign(filterListData, { "TEAM_LEADER": data.payload["Team Leader"] ?? [] });
          //setFilterListData(temp);
        }
        if (position <= 2) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "SALES_MANAGER", "value": (data.payload["Sales Manager"] ?? []) }))
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "SALES_MANAGER", "value": (data.payload["Sales Manager"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "SALES_MANAGER", "value": (data.payload["Sales Manager"] ?? []) }));
          //let temp = Object.assign(filterListData, { "SALES_MANAGER": data.payload["Sales Manager"] ?? [] });
          //setFilterListData(temp);
        }
        if (position <= 1) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "UNIT_MANAGER", "value": (data.payload["Unit Manager"] ?? []) }))
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "UNIT_MANAGER", "value": (data.payload["Unit Manager"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "UNIT_MANAGER", "value": (data.payload["Unit Manager"] ?? []) }));
          //let temp = Object.assign(filterListData, { "UNIT_MANAGER": data.payload["Unit Manager"] ?? [] });
          //setFilterListData(temp);
        }
        if (position <= 0) {
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "REGIONAL_HEAD", "value": (data.payload["Regional Head"] ?? []) }))
                          : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "REGIONAL_HEAD", "value": (data.payload["Regional Head"] ?? []) })) 
                          : dispatch(setBulkLoginFilterListDetails({ "key": "REGIONAL_HEAD", "value": (data.payload["Regional Head"] ?? []) }));
          //let temp = Object.assign(filterListData, { "REGIONAL_HEAD": data.payload["Regional Head"] ?? [] });
          //setFilterListData(temp);
        }
        setCount(count + 1);
      }
    });
  };

  const getSubConnector = (connector_id: any = null) => {
    API_SERVICE.getSubConnectors(connector_id)
      .then(({ data }) => {
        const tmpData = data.payload?.filter(
          (item: any) => item?.active
        );
        /*let temp = Object.assign(filterListData, { "SUB_CONNECTOR": tmpData ?? [] });
        setFilterListData(temp);*/
          type === "LEAD" ? dispatch(setFilterListDetails({ "key": "SUB_CONNECTOR", "value": (data.payload["Sub Connector"] ?? []) })) 
        : type === "FOLLOW_UP" ? dispatch(setFollowUpFilterListDetails({ "key": "SUB_CONNECTOR", "value": (data.payload["Sub Connector"] ?? []) })) 
        : dispatch(setBulkLoginFilterListDetails({ "key": "SUB_CONNECTOR", "value": (data.payload["Sub Connector"] ?? []) }));
        setCount(count + 1);
      })
  };

  const clearFilter = () => {
    form.resetFields();
    type === "LEAD" ? dispatch(setRestFilterData()) 
    : type === "FOLLOW_UP" ? dispatch(setFollowUpRestFilterData())
    : dispatch(setBulkLoginResetFilterData());
    getLists(userDetails?.userDetails?.userId, "");
  };

  const onFinish = () => {
    if(type === "LEAD")
    {
      let param = { "loanProductIds": lead?.loanType?[lead.loanType]:[], "location": lead.location };
    if (lead.isAssignToMe) {
      param["managerHierarchy"] = { designation: "ASSIGNED_TO_ME", managerId: userDetails?.userDetails?.userId }
    } else {
      param["managerHierarchy"] = lead.managerHierarchy
    }

    if (lead.diallerAssignmentFilter) {
      param["diallerAssignmentFilter"] = lead.diallerAssignmentFilter;
    }

    let selectedSubOrConnectorId = form.getFieldValue("SUB_CONNECTOR") ? form.getFieldValue("SUB_CONNECTOR") : form.getFieldValue("CONNECTOR");
    if (selectedSubOrConnectorId) {
      dispatch(setConnectorId(selectedSubOrConnectorId));
      param["connectorId"] = selectedSubOrConnectorId.split("-")[1];
    }
    dispatch(setFilterData(param));
    dispatch(setLeadPageNo(1))
    }
    else if (type === "FOLLOW_UP"){
      let param = { "loanProductIds": followUp?.loanType?[followUp.loanType]:[], "location": followUp.location };
      if (followUp.isAssignToMe) {
        param["managerHierarchy"] = { designation: "ASSIGNED_TO_ME", managerId: userDetails?.userDetails?.userId }
      } 
      else
      {
        param["managerHierarchy"] = followUp.managerHierarchy
      }
      if (followUp.diallerAssignmentFilter) {
        param["diallerAssignmentFilter"] = followUp.diallerAssignmentFilter;
      }
      let selectedSubOrConnectorId = form.getFieldValue("SUB_CONNECTOR") ? form.getFieldValue("SUB_CONNECTOR") : form.getFieldValue("CONNECTOR");
      if (selectedSubOrConnectorId) {
        dispatch(setFollowUpConnectorId(selectedSubOrConnectorId));
        param["connectorId"] = selectedSubOrConnectorId.split("-")[1];
      }
      dispatch(setFollowUpFilterData(param));
      dispatch(setFollowUpPageNo(1))
    }
    else
    {
      let param = { "loanProductIds": bulkLoginLead?.loanType?[bulkLoginLead.loanType]:[], "location": bulkLoginLead.location };
    if (bulkLoginLead.isAssignToMe) {
      param["managerHierarchy"] = { designation: "ASSIGNED_TO_ME", managerId: userDetails?.userDetails?.userId }
    } else {
      param["managerHierarchy"] = bulkLoginLead.managerHierarchy
    }

    if (bulkLoginLead.diallerAssignmentFilter) {
      param["diallerAssignmentFilter"] = bulkLoginLead.diallerAssignmentFilter;
    }

    let selectedSubOrConnectorId = form.getFieldValue("SUB_CONNECTOR") ? form.getFieldValue("SUB_CONNECTOR") : form.getFieldValue("CONNECTOR");
    if (selectedSubOrConnectorId) {
      dispatch(setBulkLoginConnectorId(selectedSubOrConnectorId));
      param["connectorId"] = selectedSubOrConnectorId.split("-")[1];
    }
    dispatch(setBulkLoginFilterData(param));
    dispatch(setBulkLoginPageNo(1))
    }
    
  }

  const selectAssignToMe = (value: any) => {
    /*let temp = Object.assign(selectedFilterData, { "ASSIGNED_TO_ME": value });
    setSelectedFilterData(temp);*/
    if ("true" === value){
      type === "LEAD" ? dispatch(setIsAssignToMe(true)) 
    : (type === "FOLLOW_UP") ? dispatch(setFollowUpIsAssignToMe(true))
    : dispatch(setBulkLoginIsAssignToMe(true))
    }    
    else{
      type === "LEAD" ? dispatch(setIsAssignToMe(false)) 
    : (type === "FOLLOW_UP") ?  dispatch(setFollowUpIsAssignToMe(false))
    : dispatch(setBulkLoginIsAssignToMe(false))
    }    
  }

  const handleDialerAssignmentSelect = (value: any) => {
    type === "LEAD" ? dispatch(setDiallerAssignmentFilter(value)) 
    : (type === "FOLLOW_UP") ?  dispatch(setFollowUpDiallerAssignmentFilter(value))
    : dispatch(setBulkLoginDiallerAssignmentFilter(value));;
  }

  const onSelect = (e, listFieldName) => {
    //getFilterData(name, e);
    const position = getHierarchyPosition(listFieldName);

    if (listFieldName === "CONNECTOR") {
      getSubConnector(e);
    } else if (listFieldName !== "SUB_CONNECTOR") {
      //const selectManager = {designation: listFieldName,managerId: e};
      /*let temp = Object.assign(selectedFilterData, { "managerHierarchy": selectManager });
      setSelectedFilterData(temp);*/
      type === "LEAD" ? dispatch(setManagerHierarchy({ designation: listFieldName, managerId: e })) 
      : (type === "FOLLOW_UP") ?  dispatch(setFollowUpManagerHierarchy({designation: listFieldName, managerId: e}))
      : dispatch(setBulkLoginManagerHierarchy({ designation: listFieldName, managerId: e }));
      getLists(e, listFieldName);
    }
    const tmp = [""];

    if (position <= 7) {
      tmp.push("ASSIGNED_TO_ME");
    }
    if (position <= 6) {
      tmp.push("SUB_CONNECTOR");

    }
    if (position <= 5) {
      tmp.push("CONNECTOR");
    }
    if (position <= 4) {
      tmp.push("SALES_EXECUTIVE");

    }
    if (position <= 3) {
      tmp.push("TEAM_LEADER");
    }
    if (position <= 2) {
      tmp.push("SALES_MANAGER");
    }
    if (position <= 1) {
      tmp.push("UNIT_MANAGER");
    }
    form.resetFields(tmp);

    tmp.map((item) => {
      //delete selectedFilterData[item]
    })
  }

  const getHierarchyPosition = (name): number => {
    if (name === "REGIONAL_HEAD") {
      return 1;
    } else if (name === "UNIT_MANAGER") {
      return 2;
    } else if (name === "SALES_MANAGER") {
      return 3;
    } else if (name === "TEAM_LEADER") {
      return 4;
    } else if (name === "SALES_EXECUTIVE") {
      return 5;
    } else if (name === "CONNECTOR") {
      return 6;
    } else if (name === "SUB_CONNECTOR") {
      return 7;
    }
    return 0;
  }

  const renderSelect = (name, placeHolder) => {
    //let listTemp = filterListData[`${name}`]
    let listTemp = type === "LEAD" ? lead.filterListDetails[name] 
    : type === "FOLLOW_UP" ? followUp.filterListDetails[name]
    : bulkLoginLead.filterListDetails[name]

    return (
      <Form.Item name={name} >
        <Select
          className="custom-select"
          placeholder={placeHolder}
          showSearch
          disabled={disabledDepartment.includes(name)}
          onSelect={(e: any) => {
            type === "LEAD" ? dispatch(setSelectedFilterListDetails({ key: name, value: e })) 
            : type === "FOLLOW_UP" ? dispatch(setFollowUpSelectedFilterListDetails({key: name, value: e }))
            : dispatch(setBulkLoginSelectedFilterListDetails({ key: name, value: e }));
            let id = e.split("-");
            onSelect(id.at(-1), name);
          }}
        >
          {listTemp/*?.sort(function (a: any, b: any) {
            if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) return -1;
            if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) return 1;
            return 0;
          })*/?.map((user: any) => (
            <>
              <Select.Option key={user?.userId} value={`${user?.fullName}-${user?.userId}`}>
                {user?.fullName}
              </Select.Option>
            </>
          ))}
        </Select>
      </Form.Item>
    );
  };

  const listHierarchy = [
    <List.Item key="REGIONAL_HEAD">
      {renderSelect("REGIONAL_HEAD", "Regional Head")}
    </List.Item>,
    <List.Item key="UNIT_MANAGER">
      {renderSelect("UNIT_MANAGER", "Unit Manager")}
    </List.Item>,
    <List.Item key="SALES_MANAGER">
      {renderSelect("SALES_MANAGER", "Sales Manager")}
    </List.Item>,
    <List.Item key="TEAM_LEADER">
      {renderSelect("TEAM_LEADER", "Team Leader")}
    </List.Item>,
    <List.Item key="SALES_EXECUTIVE">
      {renderSelect("SALES_EXECUTIVE", "Sales Executive")}
    </List.Item>,
    <List.Item key="CONNECTOR">
      {renderSelect("CONNECTOR", "Connector")}
    </List.Item>,
    <List.Item key="SUB_CONNECTOR">
      {renderSelect("SUB_CONNECTOR", "Sub Connector")}
    </List.Item>,
    <List.Item key="ASSIGNED_TO_ME">
      <Form.Item name="ASSIGNED_TO_ME">
        <Select className="custom-select" placeholder="Assigned To Me" /*onSelect={selectAssignToMe}*/ onSelect={selectAssignToMe}>
          <Option value="true">Yes</Option>
          <Option value="false">No</Option>
        </Select>
      </Form.Item>
    </List.Item>,
    <List.Item key="DIALLER_ASSIGNMENT_FILTER">
      <Form.Item name="DIALLER_ASSIGNMENT_FILTER">
        <Select className="custom-select" placeholder="Dialler Campaign" onSelect={handleDialerAssignmentSelect}>
          {getDiallerAssignmentOptions()}
        </Select>

      </Form.Item>
    </List.Item>,
  ];

  const listOther = [
    {
      title: "Geography",
      list: (
        <List.Item key="LOCATION">
          <Form.Item name="LOCATION">
            <Select
              className="custom-select"
              placeholder="Location"
              showSearch
              onSelect={(e) => {
                type === "LEAD" ? dispatch(setLocation(e)) 
                : type === "FOLLOW_UP"? dispatch((setFollowUpLocation(e)))
                : dispatch((setBulkLoginLocation(e)))
                /*let temp = Object.assign(selectedFilterData, { "Location": e });
                setSelectedFilterData(temp);*/
              }}
            >
              {locations?.sort(function (a: any, b: any) {
                if (a.officeName.toLowerCase() < b.officeName.toLowerCase()) return -1;
                if (a.officeName.toLowerCase() > b.officeName.toLowerCase()) return 1;
                return 0;
              })?.map((location: any) => (
                <Option key={location?.officeName} value={location?.officeName}>
                  {location?.officeName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </List.Item>
      ),
    },
    {
      title: "Loan Type",
      list: (
        <List.Item key="LOAN_TYPE">
          <Form.Item name="LOAN_TYPE">
            <Select
              className="custom-select"
              placeholder="Loan Type"
              showSearch
              onSelect={(e) => {
                type === "LEAD" ? dispatch(setLoanType(e)) 
                : type === "FOLLOW_UP" ? dispatch(setFollowUpLoanType(e))
                : dispatch(setBulkLoginLoanType(e));
                /*let temp = Object.assign(selectedFilterData, { "unitedManager": e });
                setSelectedFilterData(temp);*/
              }}
            >
              {loanTypes?.
                sort(function (a: any, b: any) {
                  if (a.loanProduct.toLowerCase() < b.loanProduct.toLowerCase()) return -1;
                  if (a.loanProduct.toLowerCase() > b.loanProduct.toLowerCase()) return 1;
                  return 0;
                })?.
                map((loan: any) => (
                  <Option key={loan?.loanProduct} value={loan?.loanProductId}>
                    {loan?.loanProduct}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </List.Item>
      ),
    },
  ];

  const btnDefaultBorderStyle: any = {'--borderColor': appColors?.appSecondaryColor ?? ""};
  const btnPrimaryStyles : any = {'--btnColor' :appColors?.appPrimaryColor ?? ""};

  return (
    <div>
      <Card style={{ width: "100%", marginBottom: "30px" }}>
        <Title level={5} style={{ marginLeft: "5px" }}>
          <Row>
            <Col span={12}> Filter By:</Col>
            <Col span={12} style={{ display: "flex", justifyContent: "end" }}><CloseOutlined onClick={() => {

              //setIsFilterVisible(false)
              type === "LEAD" ? dispatch(setIsShowFilter(false))
              : type === "FOLLOW_UP" ? dispatch(setFollowUpIsShowFilter(false))
              : dispatch(setBulkLoginIsShowFilter(false))
              // dispatch(setRestFilterData());
            }} /></Col>
          </Row>
        </Title>
        <Title level={5} style={{ display: "flex", justifyContent: "end" }}></Title>
        <Divider />
        <Form form={form} size="large" layout="vertical" autoComplete="off" onFinish={onFinish}>
          <Text style={{ marginLeft: "5px" }}>Hierarchy</Text>
          <List
            style={{ marginTop: "8px" }}
            grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
            dataSource={listHierarchy}
            renderItem={(item) => item}
          />

          <List
            style={{ marginTop: "20px" }}
            grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
            dataSource={listOther}
            renderItem={(item) => {
              return (
                <>
                  <Text style={{ marginLeft: "10px" }}>{item.title}</Text>
                  <div style={{ marginTop: "8px" }}>{item.list}</div>
                </>
              );
            }}
          />
          <Divider />
          <div style={{ textAlign: "right" }}>
            <Form.Item>
              <Space>
                <Button
                 className="dynamic-btn-default"
                 style={btnDefaultBorderStyle}
                  size="large"
                  htmlType="button"
                  onClick={clearFilter}
                >
                  Clear
                </Button>
                <Button size="large" type="primary" htmlType="submit" className="dynamic-btn-primary" style={btnPrimaryStyles}>
                  Apply Filter
                </Button>
              </Space>
            </Form.Item>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default LeadFilter;
